<template>
  <div class="account">
    <a-modal :visible="visible" @cancel="visible = false" title="代理模式" width="460px" @ok="sub">
      <a-row align="middle" justify="space-between" type="flex">
        <label>代理模式名称：</label>
        <a-input placeholder="请输入代理模式" v-model="smlform.title" style="width: 300px">
        </a-input>
      </a-row>
      <a-row align="middle" justify="space-between" type="flex" style="margin-top: 10px">
        <label>排序：</label>
        <a-input placeholder="请输入序号" v-model="smlform.sort" style="width: 300px">
        </a-input>
      </a-row>
    </a-modal>
    <div class="top wbg" v-if="$common.AUTH('agency:index')">
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            代理模式：
            <a-input v-model="form.title" placeholder="请输入代理模式" style="width: 167px">
            </a-input>
          </div>
          <div class="btns">
            <a-button type="primary" icon="search" class="ant-btn" @click="query(1)">查询</a-button>
            <a-button style="min-width: 64px;"  @click="reset">重置</a-button>
            <a-button type="primary" ghost icon="plus" @click="smlform.title = null;smlform.sort = null;visible = true" v-if="$common.AUTH('agency:add')">新增</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="tcon wbg" v-if="$common.AUTH('agency:index')">
      <div class="tableList">
        <div class="ntable" v-for="i in data" v-if="i.list.length > 0">
          <table>
            <thead>
              <td width="40%">代理模式</td>
              <td width="20%">排序</td>
              <td width="40%">操作</td>
            </thead>
            <tbody>
              <tr v-for="j in i.list">
                <td>{{ j.title }}</td>
                <td>{{ j.sort }}</td>
                <td>
                  <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del(j.id)" v-if="$common.AUTH('agency:delete')">
                    <a href="javascript:void(0);">删除</a>
                  </a-popconfirm>
                  <span class="line"></span>
                  <a href="javascript:void(0);" @click="
                      smlform = JSON.parse(JSON.stringify(j))
                      visible = true
                    " v-if="$common.AUTH('agency:edit')">修改</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pages">
        <a-pagination v-model="form.page" :total="total" show-less-items show-quick-jumper :pageSize="20" @change="turnpage" :show-total="(total) => `小计 ${total}`" />
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import {
  agencyAdd,
  agencyList,
  agencyEdit,
  agencyDel,
} from '@/server/directory'
export default {
  data() {
    return {
      smlform: { title: '', sort: null },
      form: { title: '', page: 1, limit: 20 },
      visible: false,
      data: {
        0: { list: [] },
        1: { list: [] },
      },
      total: 0,
    }
  },
  created() {
    this.query()
  },
  methods: {
    turnpage(val) {
      this.form.page = val
      this.query()
    },
    del(id) {
      agencyDel(id).then((e) => {
        this.$message.success({ content: '删除成功' })
        this.query()
      })
    },
    sub() {
      if (this.smlform.id) {
        agencyEdit(this.smlform).then((e) => {
          this.$message.success({ content: '修改成功' })
          this.visible = false
          this.query()
        })
      } else {
        agencyAdd(this.smlform).then((e) => {
          this.$message.success({ content: '新增成功' })
          this.visible = false
          this.query()
        })
      }
    },
    query() {
      agencyList(this.form).then((res) => {
        let arr = {
          0: { list: [] },
          1: { list: [] },
        }
        res.list.map((ele, index) => {
          if (index < 10) {
            arr[0].list.push(ele)
          } else {
            arr[1].list.push(ele)
          }
        })
        this.data = arr
        this.total = res.count
      })
    },
    reset(){
      this.form.limit = 20
      this.form.page = 1
      this.form.title = ''
      this.query()
    }
  },
}
</script>
<style lang="less" scoped>
.account {
  @import url("@/assets/css/topForm");
}
.tcon {
  padding: 0 20px;
  min-height: 760px;
  .tableList {
    display: flex;
    justify-content: space-between;
    .ntable {
      flex: 1;
      margin-right: 20px;
      max-width: 50%;
      table {
        width: 100%;
      }
      thead {
        td {
          height: 36px;
          background: #f4f5f9;
          border: 1px solid #efefef;
          padding-left: 60px;
        }
      }
      tbody {
        border-right: 1px solid #efefef;
        td {
          height: 54px;
          border-bottom: 1px solid #efefef;
          border-left: 1px solid #efefef;
          padding-left: 60px;
          .line {
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: #dbdcde;
            margin: 0 10px;
            vertical-align: middle;
          }
        }
      }
      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}
.pages {
  text-align: right;
}
.modal-footer {
  text-align: center;
  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
